import addDays from 'date-fns/add_days'
import addMonths from 'date-fns/add_months'
import format from 'date-fns/format'
import parseDate from 'date-fns/parse'
import ElasticsearchAPI from '../../ElasticsearchAPI'

async function targetDefinition (payload) {
  const jsonQuery = payload.query

  const attributeSet = parserSet(jsonQuery, [])
  if (attributeSet.length === 0) return parserLite(jsonQuery, attributeSet)
  const esQuery = getEsQuery(attributeSet, payload['start-date'], payload['end-date'])

  const response = await ElasticsearchAPI.targetDefinition(esQuery)
  const results = response
  return {data: parserLite(jsonQuery, esDictionary(results, attributeSet))}
}

function esDictionary (queryResults, attributeSet) {
  if (!queryResults.aggregations) return []
  const aggregations = queryResults.aggregations
  const monthCnt = aggregations.months.buckets.length || 1
  const values = []
  const addedAttributes = []

  const getDictionaryVals = (dataset) => {
    const dsUe = aggregations[`${dataset}_ue`].buckets
    for (const item of dsUe) {
      const key = item.key
      addedAttributes.push(key)

      const monthsWithDocs = item.ue_by_month.buckets.filter(m => m.doc_count > 0)
      const hasAllMonths = Math.floor(monthsWithDocs.length / monthCnt)
      const ue = item.atsg.avg_ue.value
      values.push({id: key, all_months: hasAllMonths, ue: ue})
    }
    for (const a of attributeSet.filter(a => !addedAttributes.includes(a.id) && a.dataset === dataset)) {
      values.push({id: a.id, all_months: 0, ue: 0})
    }
    return values
  }
  if (aggregations.mri_ue) values.push(...getDictionaryVals('mri'))
  if (aggregations.ncs_ue) values.push(...getDictionaryVals('ncs'))
  return values
}

function getEsQuery (attributeSet, startDate, endDate) {
  const mriIds = []
  const ncsIds = []
  for (const attr of attributeSet) {
    if (attr.dataset === 'mri') mriIds.push(attr.id)
    if (attr.dataset === 'ncs') ncsIds.push(attr.id)
  }
  function getDatasetQuery (datasetIds, startDate, endDate, dataset) {
    const atsgStart = addDays(addMonths(parseDate(endDate), -3), 1)
    return {
      'size': 0,
      'query': {
        'bool': {
          'must': [
            {'match': {'rec_type': dataset}},
            {
              'range': {
                'broadcastmonthstartdate': {'gte': startDate, 'lte': endDate, 'format': 'yyyy-MM-dd'}
              }
            },
          ]
        }
      },
      'aggs': {
        [`${dataset}_ue`]: {
          'terms': {'field': 'id', 'include': datasetIds, 'size': datasetIds.length},
          'aggs': {
            'avg_ue': {'avg_bucket': {'buckets_path': 'ue_by_month>total_ue'}},
            'ue_by_month': {
              'date_histogram': {
                'field': 'broadcastdate',
                'interval': 'month',
                'format': 'yyyy-MM-dd',
              },
              'aggs': {'total_ue': {'sum': {'field': `${dataset}_ue`}}},
            },
            'atsg': {
              'filter': {
                'range': {
                  'broadcastdate': {
                    'gte': format(atsgStart, 'YYYY-MM-DD')
                  }
                }
              },
              'aggs': {
                'ue_by_month': {
                  'date_histogram': {
                    'field': 'broadcastdate',
                    'interval': 'month',
                    'format': 'yyyy-MM'
                  },
                  'aggs': {'total_ue': {'sum': {'field': `${dataset}_ue`}}},
                },
                'avg_ue': {
                  'avg_bucket': {
                    'buckets_path': 'ue_by_month>total_ue'
                  }
                }
              }
            }
          },
        },
        'months': {
          'terms': {
            'field': 'broadcastdate',
            'format': 'yyyy-MM',
            'size': 50,
            'order': {
              '_key': 'asc'
            }
          },
          'aggs': {
            'start_date': {
              'max': {
                'field': 'broadcastmonthstartdate',
                'format': 'yyyy-MM-dd'
              }
            },
            'end_date': {
              'max': {
                'field': 'broadcastmonthenddate',
                'format': 'yyyy-MM-dd'
              }
            }
          }
        }
      },
    }
  }

  if (mriIds.length > 0) return getDatasetQuery(mriIds, startDate, endDate, 'mri')
  if (ncsIds.length > 0) return getDatasetQuery(ncsIds, startDate, endDate, 'ncs')
  return {size: 0}
}

function parserLite (targetDefinition, values) {
  for (const attr of targetDefinition) {
    if (typeof attr === 'object' && !Array.isArray(attr)) {
      if (['mri', 'ncs'].includes(attr.dataset)) Object.assign(attr, {ue: 0, removed: false})
      for (const val of values.filter(v => v.id === attr.id)) {
        Object.assign(attr, {ue: val.ue, removed: val.all_months < 1})
      }
    } else if (Array.isArray(attr)) parserLite(attr, values)
  }
  return targetDefinition
}

function parserSet (targetDefinition, result) {
  for (const attr of targetDefinition) {
    if (typeof attr === 'object' && !Array.isArray(attr)) result.push({dataset: attr.dataset, id: attr.id})
    else if (Array.isArray(attr)) parserSet(attr, result)
  }
  return result
}

export default targetDefinition



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/targetDefinition.js